const Share = () => (
    <svg
        width='15'
        height='12'
        viewBox='0 0 15 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M8.36079 3.34113V0.000976562L11.7063 3.63362L14.3887 6.54622L11.6587 9.0166L8.36079 12.001V8.7326C2.571 8.25874 0.542518 11.8968 0.542518 11.8968C0.542518 9.63015 0.714519 7.27784 2.35564 5.49664C4.2633 3.42448 7.02599 3.27784 8.36079 3.34113Z'
            fill='white'
        />
    </svg>
);

export default Share;
